<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-multiline">
          <div class="column is-12">
            <div class="box">
              <div class="columns is-multiline">
                <div class="column is-12">
                  <img class="logo_main" src="@/assets/ibs logo.png" alt="Logo ASIA IBS">
                </div>
                <div class="column is-12 pt-4 pb-6">
                  <h1 class="title">
                    Bienvenido a Asia IBS
                  </h1>
                  <p class="subtitle">
                    Elige el usuario con el que deseas ingresar
                  </p>
                </div>
                <div class="column is-12">
                  <div class="buttons is-centered">
                    <a href="https://platform.asia-ibs.com/">
                      <button class="button is-rounded">
                        Acceso Clientes
                      </button>
                    </a>
                    <a href="https://gestion.asia-ibs.com/">
                      <button class="button is-rounded">
                        Administrador
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style lang="scss" scoped>
  .hero-body {
    padding: 70px 1.5rem 35px 1.5rem;
  }
  .box {
    box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.05);
    border: solid 1px #e1e5eb;
    background-color: #ffffff;
    padding: 100px 0;
  }
  .logo_main {
    max-width: 350px;
    margin: auto;
    display: block;
  }
  .title {
    font-size: 32px;
    font-weight: bold;
    line-height: 1.56;
    text-align: center;
    color: #5d6990;
  }
  .subtitle {
    font-size: 23px;
    line-height: 2.17;
    text-align: center;
    color: #5d6990;
  }
  .buttons.is-centered:not(.has-addons) .button:not(.is-fullwidth) {
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .button {
    background-color: #3699CC;
    border: 1px solid #3699CC;
    color: white;
    font-size: 18px;
    font-weight: 500;
    width: 250px;
    height: 50px;
  }
</style>
